import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React from 'react';
import { useProfile } from 'src/features/auth/auth.hooks';
import { User } from 'src/features/users/users.types';

interface MenuItemProtected extends MenuItemProps {
  roles: string[];
  key: string;
}

const MenuItemProtected: React.FC<MenuItemProtected> = props => {
  const user = useProfile() as User;
  const { roles, children, key, ...rest } = props;

  if (roles && roles.includes(user.role)) {
    return (
      <Menu.Item key={key} {...rest}>
        {children}
      </Menu.Item>
    );
  }
  return <></>;
};

export default MenuItemProtected;
